import React from 'react';
import SectionHead from './SectionHead';
import LinkArrow from './LinkArrow';

/** `.exp-card` — encart d'expertise : visuel, titre, texte, lien. */
export const ExpertiseCard = ({ image, imageAlt, title, text, link }) => (
  <div className="exp-card">
    {image && (
      <div className="exp-visual">
        <img src={image} alt={imageAlt || ''} width="400" height="240" loading="lazy" />
      </div>
    )}
    <div className="exp-body">
      <h3>{title}</h3>
      {text && <p>{text}</p>}
      {link && <LinkArrow href={link.href}>{link.label}</LinkArrow>}
    </div>
  </div>
);

/**
 * `.exp-grid` — nombre d'encarts variable (spec 3.g), d'où `auto-fit` dans le
 * CSS plutôt que le `repeat(3,1fr)` figé de la maquette.
 */
const ExpertiseGrid = ({ title, subtitle, link, cards = [], headingLevel }) => {
  if (!cards.length) return null;
  return (
    <>
      <SectionHead title={title} subtitle={subtitle} link={link} headingLevel={headingLevel} />
      <div className="exp-grid">
        {cards.map((card, index) => (
          <ExpertiseCard key={card.title || index} {...card} />
        ))}
      </div>
    </>
  );
};

export default ExpertiseGrid;
